// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"118":"resource/js/components/login","295":"resource/js/components/dashboard","649":"resource/js/components/layouts/dashboard","844":"resource/js/components/register"}[chunkId] + ".css";
};